import React from "react";
import { Routes, Route, Navigate } from 'react-router-dom';
import Page404 from "./pages/404";
import Home from "./pages/Home";
import About from "./pages/About";
import Games from "./pages/Games";
import Jobs from "./pages/Jobs";
import Job from "./pages/Job";
import Privacy from "./pages/TextPages/Privacy";
import Terms from "./pages/TextPages/Terms";
import Game from "./pages/Game";
import Mission from "./pages/Mission";
import { ReactLenis } from "@studio-freight/react-lenis";
import './fonts/blue_curve/Bluecurve-Bold.ttf';
import './fonts/blue_curve/Bluecurve-Regular.ttf';
import './fonts/blue_curve/Bluecurve-Light.ttf';
import './fonts/isamiri_display/IsamiRiDisplayBold.ttf';
import './fonts/isamiri_display/IsamiRiDisplayRegular.ttf';

const appStyles = {
  display: 'flex',
  minHeight:'100vh',
  flexDirection: 'column'
};
const App = () => {

  return (
    <ReactLenis options={{ lerp: 0.07, duration: 0.3 }} root >
      <div id="app" className="App" style={appStyles}>

        <Routes>
          <Route
            path={'/'}
            element={
              <Home />
            }
          />
          <Route
            path={'/about'}
            element={
              <About />
            }
          />
          <Route
            path={'/mission'}
            element={
              <Mission />
            }
          />
          <Route
            path={'/games'}
            element={
              <Games />
            }
          />
          <Route
            path={'/games/:gameId'}
            element={
              <Game />
            }
          />
          <Route
            path={'/jobs'}
            element={
              <Jobs />
            }
          />
          <Route
            path={'/jobs/:jobId'}
            element={
              <Job />
            }
          />
          <Route
            path={'/privacy'}
            element={
              <Privacy />
            }
          />
          <Route
            path={'/terms'}
            element={
              <Terms />
            }
          />
          <Route
            path={'*'}
            element={
              <Page404 />
            }
          />
          <Route
            path="*"
            element={<Navigate to="/jobs" replace />}
          />
        </Routes>
      </div>
    </ReactLenis>
  );
}

export default App;
